import AssertionEntity from '../../lib/FormValidator/Assertion/AssertionEntity'
import AssertionItem from '../../lib/FormValidator/Assertion/AssertionItem'
export class RegistroEntrenadorAntecedenteAssertions extends AssertionEntity {
    private constructor() {
        super()
    }

    static build() {
        const instance = new this()
        // instance.addAssertionForName()
        return instance
    }

    // addAssertionForName(key = 'name') {
        //   this.defineAssertionForProperty(
        //     key,
        //     AssertionItem.forClosure(
        //       (value) => {
            //         return value !== ''
            //       },
            //       key,
            //       'Name is required'
            //     )
            //   )
            // }

            // }

        }

